import { render, staticRenderFns } from "./GStoryForm.vue?vue&type=template&id=756e7c53&scoped=true&"
import script from "./GStoryForm.vue?vue&type=script&lang=ts&"
export * from "./GStoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./GStoryForm.vue?vue&type=style&index=0&id=756e7c53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e7c53",
  null
  
)

export default component.exports